import apiClient from "../api/axiosConfig";
import { ENDPOINTS } from "../api/endpoints";
import {
  ApiResponse,
  LoginRequest,
  LoginResponse,
  RoleResponse,
  UserResponse,
} from "../../types/api.types";
import { LoginFormData } from "../../components/LoginForm";
import { RecoverPasswordData } from "../../components/RecoverPasswordForm";

export const authService = {
  login: async (loginRequest: LoginFormData): Promise<LoginResponse> => {
    const response = await apiClient.post<ApiResponse<LoginResponse>>(
      ENDPOINTS.AUTH.LOGIN,
      loginRequest
    );
    return response.data.data;
  },
  requestPasswordReset: async (email: string): Promise<ApiResponse<any>> => {
    const response = await apiClient.post<ApiResponse<any>>(
      ENDPOINTS.AUTH.REQUEST_PASSWORD_RESET,
      { email }
    );
    return response.data;
  },
  changePassword: async (changePasswordData: {
    currentPassword: string;
    newPassword: string;
  }): Promise<ApiResponse<any>> => {
    const response = await apiClient.post<ApiResponse<any>>(
      ENDPOINTS.AUTH.CHANGE_PASSWORD,
      changePasswordData
    );
    return response.data;
  },
  resetPassword: async (
    resetPasswordData: RecoverPasswordData
  ): Promise<ApiResponse<any>> => {
    const response = await apiClient.post<ApiResponse<any>>(
      ENDPOINTS.AUTH.RESET_PASSWORD,
      resetPasswordData
    );
    return response.data;
  },
};
